import { render } from "./rateQOQ.vue?vue&type=template&id=25128954&scoped=true"
import script from "./rateQOQ.vue?vue&type=script&lang=js"
export * from "./rateQOQ.vue?vue&type=script&lang=js"

import "./rateQOQ.vue?vue&type=style&index=0&id=25128954&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25128954"]])

export default __exports__